<template lang="html">
	<div class="inner-modal appointment-modal">
		<div class="title">
			Prise de rendez-vous
		</div>
		<div class="select-moment" v-for="(moment, key) in moments" v-bind:key="key">
			<div class="label">
				{{ moment.label }}
			</div>
			<div class="ctn-choices row">
				<div class="choice" v-for="(choice, keyt) in moment.choices" v-bind:key="keyt" :class="{active: isSelected(moment.selected, choice)}" @click="select(moment.selected, choice)">
					{{ choice }}
				</div>
			</div>
		</div>
		<div class="select-moment">
			<div class="label">
				Que est le motif de votre demande ?
			</div>
			<div class="ctn-textarea">
				<textarea v-model="purpose" placeholder="Saisir du texte ici"></textarea>
				<div class="ctn-characters">
					{{ purpose.length }} / 140
				</div>
			</div>
		</div>
		<div class="ctn-cta row">
			<div class="btn btn-red" @click="send">
				<span class="icon-button-send"></span>
				Envoyer ma demande
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'TakeAppointment',
	data () {
		return {
			moments: [
				{
					label: 'Indiquez le jour ou vous êtes disponible :',
					solo: true,
					choices: [
						'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'
					],
					selected: []
				},
				{
					label: 'Quel moment de la journéee préférez-vous ?',
					solo: true,
					choices: [
						'Matin', 'Midi', 'Après-midi', 'Soirée'
					],
					selected: []
				},
				// {
				// 	label: 'Quelle créneau préferez-vous ?',
				// 	choices: [
				// 		['7/8h', '8/9h', '9/10h', '10/11h'],
				// 		['11/12h', '12/13h'],
				// 		['13/14h', '14/15h', '15/16h', '16/17h'],
				// 		['17/18h', '18/19h', '19/20h']
				// 	],
				// 	selected: []
				// },
				{
					label: 'Y-a-t\'il des sujets que vous souhaitez aborder afin que votre conseiller prépare le rendez-vous ?',
					solo: false,
					choices: [
						'Actualité', 'Placement', 'Immobilier', 'Epargne', 'Assurance vie', 'Retraite', 'Entreprise'
					],
					selected: []
				}
			],
			purpose: ''
		}
	},
	methods: {
		isSelected (selected, item) {
			return (selected.indexOf(item) !== -1)
		},
		select (selected, item) {
			if (this.isSelected(selected, item)) {
				selected.splice(selected.indexOf(item), 1)
			} else {
				selected.push(item)
			}
		},
		send () {
			const request = {
				appointment_day: this.moments[0].selected,
				appointment_moment: this.moments[1].selected,
				appointment_subject: this.moments[2].selected,
				appointment_detail: this.purpose
			}
			this.$store.dispatch('sendAppointmentRequest', {
				request: request,
				side: {
					user: {
						id: this.user.id,
						first_name: this.user.firstname,
						last_name: this.user.lastname,
						media: { file: this.user.picture }
					}
				}
			}).then(() => {
				this.$emit('close')

				this.$notify({
					type: 'success',
					group: 'default',
					title: 'Votre demande de rendez-vous a bien été envoyée.',
					text: ''
				})
			})
		}
	},
	computed: {
		...mapGetters({
			user: 'user'
		})
	}
}
</script>

<style lang="scss" scoped>
	.btn {
		font-size: 0.8rem;
		span {
			margin-right: 0.3rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/modal/takeAppointment.vue